export default "__VITE_ASSET__49ad5636__"